import { Directive } from '@angular/core';
import { ElementRef, HostListener } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[focusSelect]',
})
export class FocusSelectDirective {
  constructor(elementRef: ElementRef) {}

  @HostListener('focus', ['$event'])
  change(event: { target: { select: () => any } }) {
    // setTimeout(() => event.target.select(), 1);
  }
}
